/** Collapsible "About this analysis" intro (UX spec §3.3, finding B1):
 *  question / inputs / method / limits / what to do with the result, from the
 *  authored content in content/analysisIntros.ts. Mounted at the top of every
 *  engineering analysis section. Unknown key renders nothing — a missing
 *  intro must never break a tab. */
import type { JSX } from 'react'
import { ANALYSIS_INTROS } from '../../content/analysisIntros.ts'

export function AboutAnalysis({ introKey }: { introKey: string }): JSX.Element | null {
  const intro = ANALYSIS_INTROS[introKey]
  if (!intro) return null
  return (
    <details className="text-xs text-gray-600 bg-gray-50 border border-gray-200 rounded-md px-3 py-2">
      <summary className="cursor-pointer select-none font-medium text-gray-700">
        About this analysis &mdash; {intro.title}
      </summary>
      <dl className="mt-2 space-y-1.5">
        <div>
          <dt className="inline font-semibold text-gray-700">What it answers: </dt>
          <dd className="inline">{intro.question}</dd>
        </div>
        <div>
          <dt className="inline font-semibold text-gray-700">What goes in: </dt>
          <dd className="inline">{intro.inputs}</dd>
        </div>
        <div>
          <dt className="inline font-semibold text-gray-700">How it works: </dt>
          <dd className="inline">{intro.method}</dd>
        </div>
        <div>
          <dt className="inline font-semibold text-gray-700">Limits: </dt>
          <dd className="inline">{intro.limits}</dd>
        </div>
        <div>
          <dt className="inline font-semibold text-gray-700">What to do with it: </dt>
          <dd className="inline">{intro.action}</dd>
        </div>
      </dl>
    </details>
  )
}
